import { zodResolver } from "@hookform/resolvers/zod";
import { Alert, Box, Button, Container, Grid, Grow, Icon, Paper, TextField, Typography } from "@mui/material";
import MyToastShow from "@/components/Layout/MyToast";
import { useContext, useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import 'react-image-picker-editor/dist/index.css';
import { useEditarEmpresaMutation } from "@/redux/api/empresaApi";
import { IEmpresa } from "@/redux/models/empresaTypes";
import { object, string } from 'zod';
import { EmpresaContext } from "../VerEmpresasPage";


const schema = object({
    nombre: string().min(1, 'El nombre no puede estar vacío'),
    email: string().refine((value) => value.length === 0 || /\S+@\S+\.\S+/.test(value), 'El email no es válido').optional().nullable(),
    descripcion: string().optional().nullable(),
    direccion: string().optional().nullable(),
    telefono: string().optional().nullable(),
});

const InformacionSection = () => {
    const { empresa, setEmpresa } = useContext(EmpresaContext);
    const [editarEmpresa] = useEditarEmpresaMutation()

    const [editMode, setEditMode] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const { register, handleSubmit, reset, formState: { errors } } = useForm<IEmpresa>({
        resolver: zodResolver(schema),
        defaultValues: empresa
    })

    const onSubmit: SubmitHandler<IEmpresa> = (data) => {
        if (empresa?.id) {
            editarEmpresa({ ...data, id: empresa.id })
                .unwrap()
                .then((response) => {
                    //@ts-ignore
                    setEmpresa(response.data)
                    MyToastShow({ message: response.message, type: 'success' })
                })
                .catch((error) => {
                    MyToastShow({ message: error?.message || 'Error al editar la empresa.', type: 'error' })
                })
        }
        setEditMode(false)
    }

    useEffect(() => {
        reset(empresa);
        setEditMode(false)
    }, [empresa, reset]);

    const onCancel = () => {
        reset(empresa)
        setEditMode(false)
        setShowAlert(false)
    }

    return (<Container>

        <Paper elevation={1} sx={{ m: 1, mt: 0 }}>

            <Box sx={{ p: 4, pt: 1 }}>
                <Typography variant="h6" gutterBottom sx={{ pb: 2 }}>Información</Typography>
                <Grid container spacing={4}>
                    <Grid item xs={6} md={4}>
                        <TextField
                            fullWidth
                            label="Nombre"
                            {...register("nombre", { disabled: !editMode })}
                            error={errors.nombre ? true : false}
                            helperText={errors.nombre?.message}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <TextField
                            fullWidth
                            label="Email"
                            {...register("email", { disabled: !editMode })}
                            error={errors.email ? true : false}
                            helperText={errors.email?.message}
                            InputLabelProps={{ shrink: true }}

                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <TextField
                            fullWidth
                            label="Descripción"
                            {...register("descripcion", { disabled: !editMode })}
                            error={errors.descripcion ? true : false}
                            InputLabelProps={{ shrink: true }}
                            helperText={errors.descripcion?.message}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <TextField
                            fullWidth
                            label="Dirección"
                            {...register("direccion", { disabled: !editMode })}
                            error={errors.direccion ? true : false}
                            helperText={errors.direccion?.message}
                            InputLabelProps={{ shrink: true }}

                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <TextField
                            fullWidth
                            label="Teléfono"
                            {...register("telefono", { disabled: !editMode })}
                            error={errors.telefono ? true : false}
                            helperText={errors.telefono?.message}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        {editMode ? (
                            <>
                                <Button type="submit" sx={{ mr: 2 }}
                                    onClick={handleSubmit(onSubmit)}
                                    variant="contained" color="success">
                                    Guardar
                                </Button>
                                <Button variant="contained" color="secondary" onClick={onCancel}>
                                    Cancelar
                                </Button>
                            </>
                        ) : (
                            <Button
                                variant="contained"
                                startIcon={<Icon>edit</Icon>}
                                color='warning'
                                onClick={() => {
                                    setEditMode(!editMode)
                                    setShowAlert(true)
                                }}
                            >
                                Comenzar a editar
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Box>


        </Paper >

        <Grow in={showAlert && editMode}>
            <Alert severity="warning" sx={{ mt: 2 }}
                onClose={() => setShowAlert(false)}
            >
                Estás en modo de edición, asegurate de guardar los cambios antes de salir
            </Alert>
        </Grow>

    </Container>

    );
}

export default InformacionSection;
